import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales people in CLASS ACTION against Management." />

      <nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/&amp;title=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;summary=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-challenge-yell_YbkW7pV.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Sales people in CLASS ACTION against Management.</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>12 March 2018</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>A crimes is now being committed against sales people, and enough is enough.</h3>
<p><br/></p>
<div className="rich-text"><p>I was having dinner with my good friends <a href="https://www.linkedin.com/in/timothyhughessocialselling/">Tim Hughes</a> and <a href="https://www.linkedin.com/in/adamgray/">Adam Gray</a> (from <em>Digital Leadership Associates</em>) last night when we got talking about the unreported crime that is now being committed against B2B sales people the world over. The crime of which I speak is the <em>restriction of duties</em> that is leading to increased sales under-performance and therefore career damage for sales people. </p><p>Whilst I’m clearly being a little melodramatic here, it’s a point that Tim, Adam and myself discussed in some details, and the more the discussion went on the more outraged we all became. Why are sales and business leaders knowingly preventing sales people from being successful? </p><p>I’m still investigating the actual law that is being broken here (if there is one) but there is one thing that I’m certain about: forcing sales people to perform duties that will only result in failure is both illogical and reckless. Reckless because it’s destroying company value for ALL stakeholders, and it’s also destroying the careers of the individual sales people whom are now, through no fault of their own, stuck in the 1980’s – being forced to treat buyers as if they were just another “number” in a pipeline that needs to be “closed”.</p></div>
<img alt="WTF" className="img-responsive" height="414" src="../../../media/images/Picture1.width-647.jpg" width="563"/>

<div className="rich-text"><p>Seriously, this crime against sales people is tantamount to asking a builder to construct a home using only a hammer, nails and a hand saw. Why would you do that? We used to burn witches at the stake back in the 12th century but thankfully we have all evolved our laws and thinking since then. I’m clearly not trained in the Law, I suspect that one could legally argue that sales people are the principal offenders – cold calling, spamming, and pushing buyers however, whilst the sales person may be the principle offender here, it’s the ‘manager’ (‘the defendant’) whom is the criminal mastermind pulling the strings. Personally, I wish these old dinosaurs would hurry up and retire so that we can get on with building the #futureofsales.</p></div>
<img alt="Mgr1" className="img-responsive" height="588" src="../../../media/images/shutterstock_179728058.width-647.jpg" width="647"/>
<p className="caption">You&#39;re ruining my career!</p>

<div className="rich-text"><p>The sales person (employees) are often being forced, against their will in most cases, to continue to perform activities that: a) Buyers now despise, b) Are sub-optimal for sales success, and c) Damage career advancement for sales people.</p><p>Of course, most crimes involve ‘a motive’ or ‘intent’ and the intent of management in this case is difficult to fathom. It is totally counter-intuitive for business leaders in 2018 to prevent their own sales teams from performing the necessary activities that actually produce the required results, but that’s exactly what is happening. Instead of listening to buyers (via the sales person) and changing the engagement model to align, managers are using the old ‘head in the sand’ technique hoping that past performance WILL be a reliable indicator of future performance. Its increasingly ludicrous, and ignorance of an offence is not a defense.</p><p>The business world is continuing to witness so-called leaders effectively restricting sales people from engaging with their buyers the way that the buyers want to be engaged - by enforcing sales people to continue to perform 20th century tactics, and the indisputable headline facts in this case are as follows:</p><p>~ Buyers don’t want to have their busy day interrupted by unsolicited outreach.</p><p>~ Buyers hate being pushed, manipulated and controlled by a desperate sales person whom reeks of commission breath.</p><p>~ Buyers dislike having their inbox cluttered with <em>spam</em> and EDM’s from unknown senders.</p><p>~ Buyers despise all forms of impersonal outreach where no attempt to research or provide personalized insights is evident.</p><p>As <a href="https://www.linkedin.com/in/djwyszynski/">Derek Wyszynski </a>often says: "why are business leaders and sales managers still asking their own sales people to sell the way that they DON'T like to buy?" Why are they committing this crime when the consequences are so damaging for all stakeholders – including themselves? The answer to this question is simple – and I have written about this in my book (<em>The Future of the Sales Profession</em>):</p><p>First, equity owning shareholders like to see their investments rapidly appreciate in value. This leads the board to instruct the CEO to improve short term company performance, in the hope this will lead to a higher share price. The CEO (knowing that their own personal bonus is tied to company performance) then gives the heads of sales and marketing new targets for the next quarter, and these targets filter down into monthly and sometimes weekly sales quotas and KPI’s, meaning that the sales leader often has no choice but to keep <em>cranking</em> the same tired old handle for what they hope will be an incremental uplift on the previous quarters performance. It’s the dreaded <em>tyranny of short-termism</em> that is at play here, and it’s the distinct lack of “back-bone” or <em>foresight</em> from management to stop for just a moment and actually listen to what the sales people are telling them about how modern buyers want to be engaged, and this is neatly summarized by Matthew Dixon of 'Challenger Sale' fame:</p></div>
<aside className="pull-quote">
    <blockquote>
        <p>&quot;What really gets in the way of driving change and simplifying things is how much leadership clings to their own assumptions about what customers want&quot;</p>
    </blockquote>
</aside>

<div className="rich-text"><p>Everyone knows that buyers no longer accept that old tactics used by sales people. A low-pressure – even no-pressure – sales approach will now result in far more sales, not to mention greater career satisfaction for its practitioners. Buyers want an <em>enjoyable</em> buying experience - they want to be <em>educated</em> with quality content, in their own time, and they want to be engaged by a specialist WHEN it suits them.</p><p>~ Is your business leader an Analogue Manager, stuck in a Digital World?</p><p>~ Is your manager preventing you from using the right tools (like social media)?</p><p>~ Is your manager knowingly contributing to your own career demise by forcing you to perform duties that inhibit your chances of success?</p><p>~ Do you feel like your career (and livelihood) is being limited by your outdated manager?</p><p>If so, then please comment on this post, and let’s see if we can create a ground swell (maybe not quite a “Class Action” but something akin it one) that drags the remaining Luddite managers- kicking and screaming no doubt - out of the 20th century and into the 21st century. </p><p>By Graham Hawkins</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/&amp;title=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;summary=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20people%20in%20CLASS%20ACTION%20against%20Management.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-people-class-action-against-management/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 